// import Vue from "vue";

export default {
  props: {
    headers: Array,
    items: Array
  },
  data: () => ({
    
  }),

  methods: {

  },
};
